import { createRouter, createWebHashHistory, } from "vue-router";
import LoadingBar from 'quasar/src/plugins/LoadingBar.js';
import { store } from '../store'
import BlankView from '@/views/Layout/basic/BlankView.vue'
// import WorkSpace from '@/views/Layout/basic/WorkSpace.vue'
import about from '@/views/Layout/About.vue'
import login from '@/views/Layout/Login.vue'
import p404 from '@/views/Layout/404.vue'

const sysKey = 0

const getAsyncRoutes = (routes) => {
    const res = []
    if (!routes) return res
    routes.forEach(item => {
        if ((item.SysID == sysKey || sysKey == 0)) {
            const newItem = {}
            if (item.RouteComponent) {
                newItem.component = () => import(`@/views${item.RouteComponent}.vue`)
            }
            newItem.path = item.RoutePath
            newItem.name = item.RouteName
            newItem.redirect = item.RouteRedirect
            if (item.IsHide) newItem.hidden = true

            if (Object.prototype.hasOwnProperty.call(item, "SysName")) {
                newItem.meta = {
                    title: item.SysName,
                    icon: item.Icon,
                    keepAlive: true
                }
            }
            else {
                newItem.meta = {
                    title: item.ModelName,
                    icon: item.RouteIcon,
                    keepAlive: true
                }
            }
            if (item.Children && item.Children.length) {
                newItem.children = getAsyncRoutes(item.Children)
            }
            res.push(newItem)
        }
    })
    return res
}
//基础路由
const basicRoutes = [
    {
        path: '/user',
        name: 'user',
        redirect: '/login',
        component: BlankView,
        children: [
            {
                path: '/login',
                name: 'login',
                component: login,
                // redirect:"/gy/home"
            }
        ]
    },
    {
        path: "/about",
        name: 'about',
        component: about
    },
    {
        path: "/404",
        name: '404',
        component: p404
    },
    {
        path: '/pdmorder',
        name: 'pdmorder',
        component: () => import('@/views/pdm/order/receiveView.vue')
    },
    {
        path: '/openXiaoChengXu',
        name: 'openXiaoChengXu',
        component: () => import('@/views/pdm/wx/openXiaoChengXu.vue')
    },
    {
        path: '/openFuWuHao',
        name: 'openFuWuHao',
        component: () => import('@/views/pdm/wx/openFuWuHao.vue')
    },
    {
        path: '/getFuWuHaoCode',
        name: 'getFuWuHaoCode',
        component: () => import('@/views/pdm/wx/getFuWuHaoCode.vue')
    },
    // {
    //     path: "/:catchAll(.*)", redirect: '404', hidden: true
    // }
]

const whiteList = ["/pdmorder","/openXiaoChengXu","/openFuWuHao","/getFuWuHaoCode"]

const getRoutes = () => {
    return [...getAsyncRoutes(store.getters['appUser/authModules'])]
}

const allRouter = basicRoutes.concat(getRoutes())

const router = createRouter({
    history: createWebHashHistory(),
    routes: allRouter
});

router.beforeEach((to, from, next) => {
    LoadingBar.start()

    if (store.getters['appUser/token']) {
        if (to.path === '/login') {
            setTimeout(() => {
                next('/gy/home')
            }, 1000);
        } else {
            store.dispatch('MultiPageBar/actOpenPage', to)

            if (store.getters['appUser/authModules'].length > 0) {
                const redirect = decodeURIComponent(from.query.redirect || to.path)
                if (redirect == '/') {
                    if (from.name === undefined) next()
                    else next({ path: "/gy/home" })
                } else {
                    if (to.path === redirect) {
                        next()
                    } else {
                        next({ path: "/gy/home" })
                    }
                }
            }
            else {
                //登陆后找不着路由跳404
                if (to.matched.length === 0) {
                    next('/404') // 判断此跳转路由的来源路由是否存在，存在的情况跳转到来源路由，否则跳转到404页面
                }
                else {
                    next()
                }
            }
        }
    } else {
        console.log("to.path=====>" + to.path)
        if (whiteList.includes(to.path)) {
            next()
        } else {
            if (from.name === 'login' || to.name === 'login') {
                next()
            } else {
                next({ path: '/login', query: { redirect: '/gy/home' } })
            }
        }
    }
})

router.afterEach((to, from) => {
    if (from.name == "login") {
        var rs = getRoutes()
        rs.forEach(v => {
            router.addRoute(v);
        })
    }
    LoadingBar.stop()
})

export default router;